module.exports = __webpack_public_path__ + "static/hcm-slider4-a7ec70dac54295980702a79258fc1dd8.jpeg";